import React, { useState, useEffect } from 'react'

import ProductHeroLayout from './ProductHeroLayout';
import { Container, Grid, TextField, Button, Typography, createTheme, Box } from '@mui/material'
import LoginIcon from '@mui/icons-material/Login';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import InfoIcon from '@mui/icons-material/Info';
import { useOnMount } from '@mui/x-data-grid/internals';
const images = ['../img/Student2.jpg', '../img/Student6.jpg', '../img/Student4.jpg', '../img/Student3.jpg', '../img/Student5.jpg', '../img/Student1.jpg'];


export default function ProductHero() {



    const month = new Date().getMonth()

    var thisYear = ''
    if (month >= 8) {
        thisYear = new Date().getFullYear() + 1
    } else {
        thisYear = new Date().getFullYear()
    }

    const [backgroundImage, setBackgroundImage] = useState('')


    useOnMount(() => {
        setBackgroundImage(images[Math.floor(Math.random() * images.length)]);
    })


    return (

        <>



            <ProductHeroLayout
                fullWidth
                sxBackground={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundColor: '#7fc7d9', // Average color of the background image.
                    fullWidth: 'calc(85vh)',
                    transition: 'background 3s linear',
                    marginTop: 0,


                }}
            >
                {/* Increase the network loading priority of the background image. */}
                <img
                    style={{ display: 'none' }}
                    src={backgroundImage}
                    alt="increase priority"
                />

                <Box mb={10} />
                <Typography color="inherit" align="center" variant="h3" marked="center" fontFamily="Times New Roman" >
                    British International College's
                </Typography>
                <Typography color="inherit" align="center" variant="h4" marked="center" fontFamily="Times New Roman" >
                    Private Candidate Portal
                </Typography>



                {/* {month === 7 && (

                <Typography color="inherit" align="center" variant="h4" marked="center" fontFamily="Times New Roman" >
                    <i>{thisYear} registrations closing soon. </i>
                </Typography>
            )} */}
                <Typography
                    color="inherit"
                    align="center"
                    variant="body2"
                    fontSize={"16px"}
                    sx={{ mb: 4, mt: { xs: 4, sm: 10 } }}


                >
                    Welcome to the British International College's online Private Candidate portal.


                    British International College assists Private Exam Candidates to enter and write Cambridge Examinations for IGCSE and A Level qualifications.

                    Students registered with BIC or BIDC and previous Private Exam Candidates can write Cambridge examinations at our accredited exam venues.
                </Typography>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"

                >
                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <Button
                                    color="secondary"
                                    variant="contained"
                                    size="large"
                                    component="a"
                                    href="/info"
                                    sx={{ minWidth: 200 }}
                                >
                                    Information Guide <InfoIcon />
                                </Button>
                            </Box>
                        </Grid>
                        {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>

                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"

                        >
                            <Button
                                color="primary"
                                variant="contained"
                                size="large"
                                component="a"
                                href="/register"
                                sx={{ minWidth: 200 }}
                            >
                                Register <AppRegistrationIcon />
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>

                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"

                        >
                            <Button
                                color="secondary"
                                variant="contained"
                                size="large"
                                component="a"
                                href="/login"
                                sx={{ minWidth: 200 }}
                            >
                                Login <LoginIcon />
                            </Button>
                        </Box>
                    </Grid> */}
                    </Grid>
                </Box>
                <Typography variant="body2" color="inherit" sx={{ mt: 2, fontStyle: 'italic' }}>
                    <a class="buttonIllum"><span> Illuminate et Optimus</span></a>
                </Typography>
                <Box mb={10} />





                <Typography variant="body2" color="inherit" sx={{ bottom: 0, marginTop: 'auto', mt: 2, fontStyle: 'italic' }}>
                    <i>©2014 British International Colleges and Schools (Pty) Ltd</i>
                </Typography>              <Typography variant="body2" color="inherit" sx={{ bottom: 0, marginTop: 'auto', mt: 2, fontStyle: 'italic', color: 'white', textDecoration: 'none' }}>
                    View website <a style={{ color: 'white' }} href='https://privatecandidate.bi-oss.co.za/tnc' target='_blank'>Terms and Conditions</a>
                </Typography>
            </ProductHeroLayout >


        </>
    );
}